if (!customElements.get('share-link')) {
  class ShareLink extends HTMLElement {
    constructor() {
      super();
      this.handleClick = () => this.share();
    }

    connectedCallback() {
      this.button = this.querySelector('button');
      this.status = this.querySelector('[data-share-status]');
      this.button?.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.handleClick);
    }

    async share() {
      const url = this.dataset.shareUrl || window.location.href;
      const title = this.dataset.shareTitle || document.title;

      if (navigator.share) {
        try {
          await navigator.share({ title, url });
          return;
        } catch (error) {
          if (error.name === 'AbortError') return;
        }
      }

      try {
        await this.copy(url);
        this.announce(this.dataset.copySuccess);
      } catch (error) {
        this.announce(this.dataset.shareError);
      }
    }

    async copy(value) {
      if (navigator.clipboard?.writeText && window.isSecureContext) {
        await navigator.clipboard.writeText(value);
        return;
      }

      const textarea = document.createElement('textarea');
      textarea.value = value;
      textarea.setAttribute('readonly', '');
      textarea.setAttribute('aria-hidden', 'true');
      textarea.tabIndex = -1;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();

      let copied = false;

      try {
        copied = document.execCommand('copy');
      } finally {
        textarea.remove();
        this.button?.focus();
      }

      if (!copied) throw new Error('Unable to copy share URL');
    }

    announce(message) {
      if (!this.status || !message) return;

      this.status.textContent = '';
      window.requestAnimationFrame(() => {
        this.status.textContent = message;
      });
    }
  }

  customElements.define('share-link', ShareLink);
}
